
import useChatScript from "~/hooks/useChatScript"

import faqConfig from '~/config/faq.json'
import type { FAQ } from "~/config/types"

export const SupportChat: () => JSX.Element = () => {
    const faq: FAQ = faqConfig
    const { toolbox } = faq.chat

    useChatScript(toolbox)

    return <div></div>
}
